import { Link } from "react-router-dom";
/// Scroll
import LogoutPage from "./Logout";
/// Image
import { Dropdown } from "react-bootstrap";
import profile from "../../../images/profile/17.jpg";

const Header = ({ onNote, toggle, onProfile, onNotification, onClick }) => {
  var path = window.location.pathname.split("/");
  return (
    <div className="header">
      <div className="header-content">
        <nav className="navbar navbar-expand">
          <div className="collapse navbar-collapse justify-content-between">
            <div className="header-left">
              <div className="dashboard_bar"></div>
            </div>
            <ul className="navbar-nav header-right">
              <Dropdown as="li" className="nav-item header-profile ">
                <Dropdown.Toggle
                  as="a"
                  to="#"
                  variant=""
                  className="nav-link i-false c-pointer"
                >
                  <div className="header-info">
                    <span className="text-black">
                      Hello,<strong>Maven</strong>
                    </span>
                    <p className="fs-12 mb-0">{localStorage.getItem("userRole") || "Super Admin"}</p>
                  </div>
                  <img src={profile} width={20} alt="" />
                </Dropdown.Toggle>
                <Dropdown.Menu align="end" className="mt-2">
                  <LogoutPage />
                </Dropdown.Menu>

              </Dropdown>
            </ul>
          </div>
        </nav>
      </div>
    </div>
  );
};

export default Header;
